import ReportCoverPage from './_components/report-cover-page'
import { Document, Font } from '@react-pdf/renderer'
import { PDFReportFeatureProps } from '.'
import ReportPage from './_components/report-page'

// Register fonts
Font.register({
  family: 'Wix Madefor Text',
  fonts: [
    { src: '/fonts/WixMadeforText-Regular.ttf', fontWeight: 400 },
    { src: '/fonts/WixMadeforText-Bold.ttf', fontWeight: 700 },
    {
      src: '/fonts/WixMadeforText-Italic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
  ],
})

export const RanchReportPDF = ({
  data,
  ability,
}: Omit<PDFReportFeatureProps, 'type'>) => {
  return (
    <Document subject="Hydra Score Report" title="Hydra Score Report">
      <ReportCoverPage data={data} ability={ability} type="ranch" />
      <ReportPage data={data} ability={ability} type="ranch" />
    </Document>
  )
}
